import React from 'react'

// Componentes
import Sticky from '../../components/shared/react-sticky/sticky.js'
import StickyContainer from '../../components/shared/react-sticky/container.js'
import HeaderConFiltro from '../../components/shared/HeaderConFiltro.jsx'

// Styles
import * as css from './TablaAuditoriaSemanal.css'

class TablaAuditoriaSemanal extends React.Component{
    render(){
        return (
            <StickyContainer type={React.DOM.table}  className={"table table-bordered table-condensed "+css.tableFixed}>
                <colgroup>
                    <col className={css.thCorrelativo}/>
                    <col className={css.thCorrelativo2}/>
                    <col className={css.thFecha}/>
                    <col className={css.thCliente}/>
                    <col className={css.thCeco}/>
                    <col className={css.thTienda}/>
                    <col className={css.thRegion}/>
                    <col className={css.thComuna}/>
                    <col className={css.thDireccion}/>
                    <col className={css.thAuditor}/>
                    <col className={css.thCantidadMuestra}/>
                    <col className={css.thCantidadMuestra}/>
                    <col className={css.thSuspendido}/>
                    <col className={css.thObservaciones}/>
                    <col className={css.thLink}/>
                    <col className={css.thLink}/>
                    <col className={css.thLink}/>
                </colgroup>
                <thead>
                    {/* TR que se pega al top de la pagina, es una TR, con instancia de 'Sticky' */}
                    <Sticky
                        topOffset={-50}
                        type={React.DOM.tr}
                        stickyStyle={{top: '50px'}}>

                        <th className={css.thCorrelativo}>#</th>
                        <th className={css.thCorrelativo}>
                            <HeaderConFiltro
                                nombre=''
                                filtro={this.props.filtros.filtroFacturables || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroFacturables')}
                                //ordenarLista={this.props.ordenarAuditorias}
                            />
                        </th>
                        <th className={css.thFecha}>
                            <HeaderConFiltro
                                nombre='Fecha'
                                filtro={this.props.filtros.filtroFechas || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroFechas')}
                                ordenarLista={this.props.ordenarAuditorias}
                            />
                        </th>
                        <th className={css.thCliente}>
                            <HeaderConFiltro
                                nombre="CL"
                                filtro={this.props.filtros.filtroClientes || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroClientes')}
                                busquedaExacta={true}
                            />
                        </th>
                        <th className={css.thCeco}>
                            <HeaderConFiltro
                                nombre="CE"
                                filtro={this.props.filtros.filtroCeco || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroCeco')}
                                busquedaExacta={true}
                            />
                        </th>
                        <th className={css.thTienda}>Tienda</th>
                        <th className={css.thRegion}>
                            <HeaderConFiltro
                                nombre="R"
                                filtro={this.props.filtros.filtroRegiones || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroRegiones')}
                                busquedaExacta={true}
                            />
                        </th>
                        <th className={css.thComuna}>
                            <HeaderConFiltro
                                nombre="Comuna"
                                filtro={this.props.filtros.filtroComunas || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroComunas')}
                            />
                        </th>
                        <th className={css.thDireccion}>Dirección</th>
                        <th className={css.thAuditor}>
                            <HeaderConFiltro
                                nombre="Auditor"
                                filtro={this.props.filtros.filtroAuditores || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroAuditores')}
                            />
                        </th>
                        {this.props.puedeRevisarCantidadMuestras ?
                            <th className={css.thCantidadMuestra}>
                                <HeaderConFiltro
                                    nombre="Obl"
                                    filtro={this.props.filtros.filtroMuestraO || []}
                                    actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroMuestraO')}
                                />
                            </th>
                            :
                            <th className={css.thCantidadMuestra}>Obl</th>
                        }
                        {this.props.puedeRevisarCantidadMuestras?
                            <th className={css.thCantidadMuestra}>
                                <HeaderConFiltro
                                    nombre="Dif"
                                    filtro={this.props.filtros.filtroMuestraD || []}
                                    actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroMuestraD')}
                                />
                            </th>
                            :
                            <th className={css.thCantidadMuestra}>Dif</th>    
                        }
                            
                           
                        <th className={css.thSuspendido}>
                            <HeaderConFiltro
                                nombre="Suspendido"
                                filtro={this.props.filtros.filtroSuspendidos || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroSuspendidos')}
                            />
                        </th>
                        <th className={css.thObservaciones}>
                            <HeaderConFiltro
                                nombre="Observaciones"
                                filtro={this.props.filtros.filtroObservaciones || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroObservaciones')}
                            />
                        </th>
                        <th className={css.thDescargaIrd}>
                            <HeaderConFiltro
                                nombre="Baja"
                                filtro={this.props.filtros.filtroDescargaIrd || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroDescargaIrd')}
                            />
                        </th>
                        <th className={css.thLink}>
                            <HeaderConFiltro
                                nombre="Zip"
                                filtro={this.props.filtros.filtroZip || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroZip')}
                            />
                        </th>
                        <th className={css.thLink}>
                            <HeaderConFiltro
                                nombre="Acta"
                                filtro={this.props.filtros.filtroResultado || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroResultado')}
                            />
                        </th>
                    </Sticky>
                </thead>
                <tbody>
                    {this.props.children}
                </tbody>
            </StickyContainer>
        )
    }
}
TablaAuditoriaSemanal.propTypes = {
    // Objetos
    filtros: React.PropTypes.objectOf(React.PropTypes.array).isRequired,
    // Metodos
    ordenarAuditorias: React.PropTypes.func.isRequired,
    actualizarFiltro: React.PropTypes.func.isRequired
}
export default TablaAuditoriaSemanal


// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/TablaAuditoriaSemanal.jsx